import React, { memo, useMemo } from 'react'
import '../index.css'

const RifterCard = memo(({ rifter, searchTerm, highlightText }) => {
  const {
    article,
    author,
    artist,
    page,
    issue,
    issueTitle,
    summary,
    games,
    official
  } = rifter

  // Memoize expensive computations
  const joinedAuthor = useMemo(() => author.join(', '), [author])
  const joinedArtist = useMemo(() => artist.join(', '), [artist])
  const gameTags = useMemo(() => games.map((g, i) => <span key={i}>{g}</span>), [games])

  // Create highlighted text
  const highlightedTitle = useMemo(() => {
    if (!searchTerm || !highlightText) return issueTitle
    return highlightText(issueTitle, searchTerm)
  }, [issueTitle, searchTerm, highlightText])

  const highlightedArticle = useMemo(() => {
    if (!searchTerm || !highlightText) return article
    return highlightText(article, searchTerm)
  }, [article, searchTerm, highlightText])

  const highlightedSummary = useMemo(() => {
    if (!searchTerm || !highlightText) return summary
    return highlightText(summary, searchTerm)
  }, [summary, searchTerm, highlightText])

  if (!issue || issue === 'N/A') {
    return null
  }

  return (
    <article className='rifter-card-container' aria-labelledby={`title-${rifter.id || issueTitle}`}>
      <div className='image-container'>
        <img src={issue} alt={`Cover of ${issueTitle}`} loading="lazy" />
      </div>
      <div className='rifter-info'>
        {official === 'Yes' ? <span className='official-tag' aria-label='Official content'>Official</span> : null}
        <div>
          <h2 id={`title-${rifter.id || issueTitle}`} dangerouslySetInnerHTML={{ __html: highlightedTitle }} />
          <h3>&ldquo;<span dangerouslySetInnerHTML={{ __html: highlightedArticle }} />&rdquo;, <span className='subName'>Page(s): {page}</span></h3>
          <h5>Author(s): <span className='h5-noBold'>{joinedAuthor}</span></h5>
          <h5>Artist(s): <span className='h5-noBold'>{joinedArtist}</span></h5>
        </div>
        <div>
          <p dangerouslySetInnerHTML={{ __html: highlightedSummary }} />
        </div>
        <div className='tags-container' role='list' aria-label='Game systems'>
          {gameTags}
        </div>
      </div>
    </article>
  )
})

RifterCard.displayName = 'RifterCard'

export default RifterCard
